import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

function ProgressBar({ label, used, limit, unlimited, color }) {
  const percent = unlimited ? 0 : Math.min(100, Math.round((used / limit) * 100));
  const isWarning = !unlimited && percent >= 80;
  const isDanger = !unlimited && percent >= 100;

  let barColor = color;
  if (isDanger) barColor = "#ef4444";
  else if (isWarning) barColor = "#f59e0b";

  return (
    <div style={{ marginBottom: "16px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px", fontSize: "13px" }}>
        <span style={{ color: "#374151", fontWeight: 500 }}>{label}</span>
        <span style={{ color: isDanger ? "#ef4444" : "#6b7280" }}>
          {unlimited ? (
            <span style={{ color: "#22c55e", fontWeight: 500 }}>∞ Безлимит</span>
          ) : (
            <>{used} / {limit} {isDanger && "— лимит достигнут"}</>
          )}
        </span>
      </div>

      {!unlimited && (
        <div style={{
          width: "100%",
          height: "8px",
          background: "#f3f4f6",
          borderRadius: "999px",
          overflow: "hidden",
        }}>
          <div style={{
            width: `${percent}%`,
            height: "100%",
            background: barColor,
            transition: "width .3s",
            borderRadius: "999px",
          }} />
        </div>
      )}
    </div>
  );
}

export default function LimitsWidget() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/api/dashboard/limits`, { credentials: "include" })
      .then(r => r.ok ? r.json() : null)
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div style={{ background: "white", padding: "20px", borderRadius: "16px", marginBottom: "20px" }}>
        <div style={{ height: "16px", background: "#f3f4f6", borderRadius: "6px", marginBottom: "10px", width: "40%" }} />
        <div style={{ height: "8px", background: "#f3f4f6", borderRadius: "6px", marginBottom: "16px" }} />
        <div style={{ height: "8px", background: "#f3f4f6", borderRadius: "6px" }} />
      </div>
    );
  }

  if (!data) return null;

  const { limits, plan, plan_title, plan_expires } = data;

  // Есть ли превышение хоть по одному лимиту?
  const hasLimitHit =
    (!limits.smtpAccounts.unlimited && limits.smtpAccounts.used >= limits.smtpAccounts.limit) ||
    (!limits.recipients.unlimited && limits.recipients.used >= limits.recipients.limit) ||
    (!limits.emailsPerMonth.unlimited && limits.emailsPerMonth.used >= limits.emailsPerMonth.limit);

  const planColor = plan === 'free' ? "#6b7280" : plan === 'test' ? "#3b82f6" : plan === 'gold' ? "#eab308" : "#8b5cf6";

  return (
    <div style={{
      background: "white",
      padding: "20px",
      borderRadius: "16px",
      marginBottom: "20px",
      border: "1px solid #e5e7eb",
    }}>
      {/* Заголовок */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "10px" }}>
        <div>
          <h2 style={{ fontSize: "18px", fontWeight: 600, marginBottom: "4px" }}>
          Использование лимитов
          </h2>
          <div style={{ fontSize: "13px", color: "#6b7280" }}>
            Ваш активный тариф: <span style={{ color: planColor, fontWeight: 600 }}>{plan_title}</span>
            {plan_expires && plan !== 'free' && (
              <> · действует до {new Date(plan_expires).toLocaleDateString('ru-RU')}</>
            )}
          </div>
        </div>

        {plan === 'free' && (
          <Link
            to="/pricing"
            style={{
              background: "#2563eb",
              color: "white",
              padding: "8px 16px",
              borderRadius: "10px",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            Улучшить тариф →
          </Link>
        )}
      </div>

      {/* Прогресс-бары */}
      <ProgressBar
        label="Почты для отправки"
        used={limits.smtpAccounts.used}
        limit={limits.smtpAccounts.limit}
        unlimited={limits.smtpAccounts.unlimited}
        color="#3b82f6"
      />

      <ProgressBar
        label="Активные получатели"
        used={limits.recipients.used}
        limit={limits.recipients.limit}
        unlimited={limits.recipients.unlimited}
        color="#8b5cf6"
      />

      <ProgressBar
        label="Письма в этом месяце"
        used={limits.emailsPerMonth.used}
        limit={limits.emailsPerMonth.limit}
        unlimited={limits.emailsPerMonth.unlimited}
        color="#22c55e"
      />

      {/* Предупреждение, если лимит достигнут */}
      {hasLimitHit && (
        <div style={{
          background: "#fef2f2",
          border: "1px solid #fecaca",
          color: "#991b1b",
          padding: "12px 16px",
          borderRadius: "12px",
          marginTop: "12px",
          fontSize: "14px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "10px",
        }}>
          <span>⚠️ Достигнут лимит на текущем тарифе. Дальнейшие действия заблокированы.</span>
          <Link
            to="/pricing"
            style={{
              background: "#ef4444",
              color: "white",
              padding: "6px 14px",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: 500,
              fontSize: "13px",
            }}
          >
            Обновить тариф
          </Link>
        </div>
      )}
    </div>
  );
}